import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService";
import { DashboardWorkItemsStatResponse } from "./dashboard";

const fetchDashboardStats = async (): Promise<DashboardWorkItemsStatResponse> => {
    const stats = await apiInputService.get("/frontend/dashboard/workItemsStats")
    const { data } = stats;

    return data;
}


export const useDashboardWorkItemStats = (options?: any) => {

    const { subscription } = useSubscription();

    return useQuery<DashboardWorkItemsStatResponse>(
        ["dashboard", "stats", "workitem", subscription], 
        () => fetchDashboardStats(), {
        ...options,
        enabled: !!subscription,
        staleTime: 0,
    });
}